require('publication.js');
require('modal.js');
require('comments.js');
require('scroll-to-hash.js');
require('readmore.js');
require('ElementToA-3.0.js');
require('slick.js')

import NewsletterForm from 'register-newsletter.js';

import $ from 'jquery';

$(document)
.on('click', '.header_icon-themes', function(ev) {
    $(ev.currentTarget).addClass('opened');
    $('body').addClass('menu-opened');
})
.on('click', '.header_icon-search', function(ev) {
    $(ev.currentTarget).addClass('opened');
    $('body').addClass('search-opened');
})
.on('click', '#commentaires_accordion .accordion-cta .more', function(e) {
    $("#commentaires").smoothScrollTo();
    $(this).parents('#commentaires_accordion').removeClass('resume').addClass('every-posts');
    return false;
})
.on('click', '#commentaires_accordion .accordion-cta .less', function(e) {
    $("#commentaires").smoothScrollTo();
    $(this).parents('#commentaires_accordion').removeClass('every-posts').addClass('resume');
    return false;
})
.on('click', '.static_grid_item:not(.active)', e => {
    $(e.currentTarget).addClass('active');
    e.stopPropagation();
})
.on('click', '.publication_sommaire a', e => {
    const target = $(e.currentTarget).attr('href');
    $(target).smoothScrollTo();
})
.on('click', '.hero a', e => {
    const target = $(e.currentTarget).attr('href');
    $(target).smoothScrollTo();
})
.on('click', '.header_social_newsletter', e => {
    $('#register-newsletter').smoothScrollTo();
})
.on('click', '.publication_actions_icon', e => {
    $('.publication_actions').toggleClass('active');
})
.on('click', '.publication_reco_side-button', function(ev) {
    document.getElementById('recos').classList.toggle('opened');
})
.on('click', '.event_close', e => {
    const root = $(e.currentTarget).parent('.event');
    const id = root.attr('data-event-id');
    root.remove();
    const hideCookie = document.cookie.split(';').filter(cookie => {
        return cookie.trim().indexOf('hide=') === 0;
    });
    if (hideCookie.length) {
        document.cookie = hideCookie[0] + ',' + id;
    } else {
        document.cookie = 'hide=' + id;
    }
});

function closeMenu() {
    $('#themes').removeClass('opened');
    $('#kubs').removeClass('opened');
    $('body').removeClass('menu-opened');
}
$(document).keyup(function(e) {
    if (e.keyCode == 27) {
        // escape key maps to keycode `27`
        closeMenu();
    }
});

function closeSearchMenu() {
    $('#recherche').removeClass('opened');
    $('body').removeClass('search-opened');
}


function menu() {
    $('.newsletter').on('click', function(e) {
        $('#recherche, #themes').removeClass('opened');
        $('body').removeClass('search-opened');
        $('body').removeClass('menu-opened');
    });
    $('.header_button--themes').on('click', function(e) {
        $('#themes').addClass('opened');
        $('body').addClass('menu-opened');
        $('#recherche').removeClass('opened');
        $('body').removeClass('search-opened');
    });
    $('.header_button--close').on('click', function(e) {
        closeMenu();
    });

    $('.header_button--kubs').on('click', function(e) {
        $('#kubs').addClass('opened');
        $('body').addClass('menu-opened');
        $('#recherche').removeClass('opened');
        $('body').removeClass('search-opened');
    });

    $('.search_icon').on('click', function(e) {
        $('#recherche').addClass('opened');
        $('body').addClass('search-opened');
        $('#themes').removeClass('opened');
        $('body').removeClass('menu-opened');
        $( "#search_input" ).focus();
    });
    $('.search_icon--close').on('click', function(e) {
        closeSearchMenu();
    });
    $(window).on('scroll', function() {
        var scrollPos = window.pageYOffset;
        var mainPos = $('.hero').height();

        if (scrollPos > 100) {
            $('.header, body').addClass('scrolled');
        } else $('.header, body').removeClass('scrolled');
    });

    $('.header_search_input').on('focus', function(e) {
        $('.header_search').addClass('active');
        $('.header_search_input').focus();
    });
    $('.header_search svg')
    .not('.active')
    .on('click', function(e) {
        e.stopPropagation();
        $('.header_search').addClass('active');
        $('.header_search_input').focus();
    });
    $('.header_search.active svg').on('click', function(e) {
        e.stopPropagation();
        $(this)
        .siblings('form')
        .submit();
    });
    $('.header_search_input').on('blur', function(e) {
        $('.header_search').removeClass('active');
    });

    $('.main_up').on('click', function(e) {
        $('html,body').animate({scrollTop: 0}, 'slow');
        return false;
    });
}



function forms() {
    const $inputs = $(
        'form input:not([type]),form input[type=text],form input[type=password],form input[type=email],form input[type=url],form input[type=time],form input[type=date],form input[type=datetime],form input[type=datetime-local],form input[type=tel],form input[type=number],form input[type=search]',
    );
    $inputs.on('focus', function(e) {
        $(this)
        .siblings('label')
        .addClass('active');
    });
    $(window).on('load', function() {
        $inputs.each(function(i) {
            if ($(this).val()) {
                $(this)
                .siblings('label')
                .addClass('not-empty');
            }
        });
    });
    $inputs.on('blur', function(e) {
        if (!$(this).val()) {
            $(this)
            .siblings('label')
            .removeClass('not-empty');
        } else
            $(this)
        .siblings('label')
        .addClass('not-empty');

        $(this)
        .siblings('label')
        .removeClass('active');
    });
    $('.publication .form--white input[type=radio]').on('change', function(e) {
        if (this.checked) {
            $(this)
            .closest('li')
            .addClass('active');
            $(this)
            .closest('li')
            .nextAll('li')
            .addClass('active');
            $(this)
            .closest('li')
            .prevAll('li')
            .removeClass('active');
        }
    });
    $('.form input[type=radio]').on('change', function(e) {
        if (this.checked) {
            $(this)
            .closest('ul')
            .find('.active')
            .removeClass('active');
            $(this)
            .closest('li')
            .toggleClass('active');
        }
    });

    $('.form input[type=checkbox]').on('change', function(e) {
        if (this.checked) {
            $(this)
            .closest('li')
            .addClass('active');
        } else
            $(this)
        .closest('li')
        .removeClass('active');
    });
    $('.form input[type=radio]').each(function(i) {
        if (this.checked) {
            $(this)
            .closest('li')
            .toggleClass('active');
        }
    });

    $('.form input[type=checkbox]').each(function(i) {
        if (this.checked) {
            $(this)
            .closest('li')
            .addClass('active');
        }
    });

    $('.form input[type=checkbox], .form input[type=radio]').each(function(i) {
        $(this)
        .closest('label')
        .addClass($(this).attr('type'));
    });
}

function search() {
    $('.search_filters span').on('click', function(e) {
        e.stopPropagation();
        $('.search_filters .active').removeClass('active');
        $(this)
        .siblings('ul')
        .toggleClass('active');
    });
}
$(window).click(function() {
    $('.search_filters ul').removeClass('active');
});


$(function() {
    const newsletterForm = new NewsletterForm($('form#newsletter-register-form'));
    newsletterForm.init();

    menu();

    if (location.hash) {
        $(location.hash).smoothScrollTo();
    }

    forms();
    search();
    $('a').each(function() {
        var a = new RegExp('/' + window.location.host + '/');
        if (!a.test(this.href)) {
            $(this).attr('target', '_blank');
        }
    });
});

$(window).on('scroll', function() {
    var scrollPos = window.pageYOffset;
    if ( $('#commentaires').length ) {
        var commPos = $('#commentaires').position();
        var maxScrollPos = 550;
    } else {
        var commPos = $('.publication_reco').position();
        var maxScrollPos = 350;
    }
    if (typeof $('#recos').position() !== 'undefined') {
      var recoPosTop = commPos.top - $('.publication_reco_side').height() - 80 ;

      if (scrollPos > maxScrollPos && scrollPos < recoPosTop ) {
        $('.publication_reco_side').addClass('scrolled');
      } else {
        $('.publication_reco_side').removeClass('scrolled');
      }
    }

    if (typeof $('#commentaires').position() !== 'undefined') {
      var commPosTop = commPos.top - $('.publication_info').height() + 70;

      if (scrollPos > 550 && scrollPos < commPosTop ) {
        $('.publication_info').addClass('scrolled');
      } else {
        $('.publication_info').removeClass('scrolled');
      }
    }
  });

$(document).ready(function(){
    $('.digests-carousel').slick({  // carrousel management
        slidesToShow: 4,
        slide: 'div',
        slidesToScroll: 4,
        centerMode: false,
        dots:true,
        easing: 'swing',
        responsive: [
            {
              breakpoint: 880,
              settings: {
                slidesToShow:2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 680,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }]
    });

    $('.publication_sommaire > span').on("click", () => {  // dropdown menu on mobile
        let span = $('.publication_sommaire > span')[0];
        let ul = $('.publication_sommaire > ul')[0];

        if (ul.classList.contains("mobileClosed")) {
            ul.classList.remove("mobileClosed");
            span.classList.remove("mobileClosed");
        } else {
            ul.classList.add("mobileClosed");
            span.classList.add("mobileClosed");
        }
    });

    // Correct the scroll to anchor problem
    // Using slick, the browser loads the images placeholders, then slick
    // reorganizes the page layout, so it creates an offset
    // This code scrolls to right position 100 ms after the page is "ready"
    if(window.location.hash) {  
        $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top - 10
        }, 100);
    }
});


// WEBPACK FOOTER //
// ./entrypoints/main.js